import * as Yup from "yup";

export const ValidationSchema = (t: any) =>
    Yup.object().shape({
        title: Yup.string().required("Title is required!").min(1).max(128),
        context: Yup.string().required("Context is required!").min(1),
    });
